import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=1600&auto=format&fit=crop&q=80"
          alt="Rolling green farmland"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#2D5016]/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          Join the Good Grains Community!
        </h2>
        <p className="text-white/80 text-lg md:text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
          Stay in the loop on new products and animal care tips. Contact us today to learn more or place your order. We're here to help your animals thrive.
        </p>
        <Link
          to="/shop"
          className="inline-block px-10 py-4 rounded-lg bg-[#D4A84B] text-[#3B2F1E] font-bold text-lg hover:bg-[#c49a3d] transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1"
        >
          Shop Now
        </Link>
      </div>
    </section>
  );
};

export default CTASection;
